import script from "./FirstLevelSupportChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirstLevelSupportChat.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./FirstLevelSupportChat.vue?vue&type=style&index=0&id=b45ba16c&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-b45ba16c"]])

export default __exports__